import React from 'react';

import { FormControl, Glyphicon } from 'react-bootstrap';
import styled from 'styled-components';

import '../../../styles/components/PhotoWidget.css';
import { generateKeyStr } from '../../../infrastructure/utils/common';
import { PhotoInfo } from '../../../types/PhotoInfo';

import FileUploader from './FileUploader';

type Props = {
  header: string;
  onChange(e: React.ChangeEvent<HTMLInputElement>): void;
  image: PhotoInfo | string | undefined;
  fileStatus?: string;
  loadkey?: string;
  required?: boolean;
  width?: string;
  full?: boolean;
  height?: string;
  onError?(): void;
  readOnly?: boolean;
  noDragnDrop?: boolean;
};

type ImageProps = {
  width: string;
  height: string;
};

const Image = styled.img<ImageProps>`
  width: ${({ width }) => (width ? width : '100px')};
  height: ${({ height }) => (height ? height : '100px')};
  display: inline-block;
`;

export default ({
  header,
  onChange,
  fileStatus,
  loadkey,
  required,
  width,
  full,
  height,
  onError,
  image,
  readOnly,
  noDragnDrop,
}: Props) => {
  const { isNew, blob, data = '' } = (image as PhotoInfo) ?? {};
  const key = loadkey || generateKeyStr();
  let src: string | undefined;
  if (data) {
    if (isNew || blob) src = data;
    else src = `${data}?p=${key}`;
  } else {
    src = image as string;
  }
  if (readOnly) {
    return <Image src={src} onError={onError} />;
  }

  return (
    <>
      {!src ? (
        <div className='col-md-2' style={{ paddingLeft: '0px' }}>
          <FileUploader
            onChange={onChange}
            width={width}
            full={full}
            height={height}
            header={header}
            required={required}
            name='general'
            fileStatus={fileStatus}
            noDragnDrop={noDragnDrop}
          />
        </div>
      ) : (
        <div
          className='upload-file-input-wrapper'
          style={{ width: width || '100px', height: height || '100px' }}
        >
          <div
            className='col-md-3 photo-view'
            style={{ paddingLeft: '0px', marginBottom: '20px' }}
          >
            <Image src={src} onError={onError} />
            <div className='upload-str' style={{ width }}>
              <Glyphicon glyph='open' style={{ marginRight: '10px' }} />
              Upload new
            </div>
          </div>
          <FormControl
            data-type='general'
            onChange={onChange}
            accept='.jpg, .png'
            type='file'
          />
        </div>
      )}
    </>
  );
};
